import { ChevronLeftIcon, ChevronRightIcon } from "lucide-react";

import { cn } from "@tudigo-monorepo/core-tudigo-theme";
import { ButtonRebrand } from "@tudigo-monorepo/web-tudigo-components";

import { useComparator } from "../comparator.context";
import { useComparatorScroller } from "./store/hooks/use-comparator-scroller";

const FLOATING_BUTTON_CN =
  "z-comparator-scroller-buttons hover:bg-black-400 border-neutral-800 absolute bottom-1/2 top-1/2 h-8 w-8 -translate-y-1/2 transform rounded-full bg-white opacity-100 transition-opacity duration-200";

function ComparatorScrollerFloatingButtons() {
  const {
    state: { canScrollPrev, canScrollNext },
    scrollPrev,
    scrollNext,
  } = useComparatorScroller();

  return (
    <>
      <ButtonRebrand
        onClick={scrollPrev}
        variant="secondary"
        className={cn(
          FLOATING_BUTTON_CN,
          "left-4",
          !canScrollPrev && "opacity-0",
        )}
      >
        <ChevronLeftIcon className="min-h-4 min-w-4 text-neutral-900" />
      </ButtonRebrand>
      <ButtonRebrand
        onClick={scrollNext}
        variant="secondary"
        className={cn(
          FLOATING_BUTTON_CN,
          "right-4",
          !canScrollNext && "opacity-0",
        )}
      >
        <ChevronRightIcon className="min-h-4 min-w-4 text-neutral-900" />
      </ButtonRebrand>
    </>
  );
}

function ComparatorScrollerPrevious({ className }: { className?: string }) {
  const {
    state: { canScrollPrev, locked },
    scrollPrev,
  } = useComparatorScroller();

  return (
    <ButtonRebrand
      onClick={scrollPrev}
      variant="secondary"
      disabled={locked || !canScrollPrev}
      className={cn(
        "h-14 w-14 rounded-full bg-white",
        canScrollPrev && "border-neutral-800",
        locked && "disabled:opacity-100",
        className,
      )}
    >
      <ChevronLeftIcon className="min-h-4 min-w-4 text-neutral-900" />
    </ButtonRebrand>
  );
}

function ComparatorScrollerNext({ className }: { className?: string }) {
  const {
    state: { canScrollNext, locked },
    scrollNext,
  } = useComparatorScroller();

  return (
    <ButtonRebrand
      onClick={scrollNext}
      variant="secondary"
      disabled={locked || !canScrollNext}
      className={cn(
        "h-14 w-14 rounded-full bg-white",
        canScrollNext && "border-neutral-800",
        locked && "disabled:opacity-100",
        className,
      )}
    >
      <ChevronRightIcon className="min-h-4 min-w-4 text-neutral-900" />
    </ButtonRebrand>
  );
}

function ComparatorScrollerButtons({ className }: { className?: string }) {
  const { selectionCount } = useComparator();

  const {
    state: { scrollPosition },
  } = useComparatorScroller();

  return (
    <div className={cn("flex items-center justify-center gap-x-4", className)}>
      <ComparatorScrollerPrevious />
      <span className="font-roobert inline-block w-5 text-sm font-semibold sm:hidden">
        {scrollPosition + 1}/{selectionCount}
      </span>
      <span className="font-roobert hidden text-sm font-semibold sm:inline-block">
        Défiler
      </span>
      <ComparatorScrollerNext />
    </div>
  );
}

export {
  ComparatorScrollerButtons,
  ComparatorScrollerFloatingButtons,
  ComparatorScrollerPrevious,
  ComparatorScrollerNext,
};
